import React, { useState } from 'react';
import { useAuth } from '../../context';
import { Input, Card } from '../../components/common';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { paths } from '../../routing/paths';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import AppButton from '../../components/common/AppButton';

const ResetPassword = () => {
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get('oobCode');
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [passwordReset, setPasswordReset] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password || !confirmPassword) {
      setError('Please enter and confirm your new password');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (!oobCode) {
      setError('Invalid password reset link. Please try again.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await resetPassword(oobCode, password);
      setPasswordReset(true);
    } catch (err) {
      setError('Failed to reset password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 4,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 320, padding: 4 }} elevation={0}>
        <Typography variant="h5" align="center" gutterBottom>
          Reset Password
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {passwordReset ? (
          <>
            <Alert severity="success" sx={{ mb: 2 }}>
              Your password has been reset successfully. You can now login with your new password.
            </Alert>
            <AppButton isFullWidth style={{ marginTop: 16 }} onClick={() => navigate(paths.login)}>
              Login
            </AppButton>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <Input
              type="password"
              label="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Input
              type="password"
              label="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={{ marginTop: 16 }}
            />
            <AppButton type="submit" isFullWidth isLoading={loading} style={{ marginTop: 16 }}>
              Reset Password
            </AppButton>
          </form>
        )}
      </Card>
    </Box>
  );
};

export default ResetPassword;
